/**
 * §3 Steps —— wf-steps-section（三步领取 $100）
 *
 * 需求来源：提示词 第1次提交（DEV-124229）；原型 L5066-5363。
 *
 * 注意事项：
 * 1. 两个连接箭头 .wf-step-arrow--1/--2 是 **.wf-steps-grid 的绝对定位子元素**（压在卡片之间），
 *    不属于任何一张卡；桌面端按列百分比定位，≤767 由 CSS 转成竖排（本页 index.less 里
 *    按 D7 把手机端改成 position:static 随流排布，原因见该文件末尾注释）。
 * 2. 【D7④】原型两个箭头的偏移量不对称（--1 为 32px、--2 为 24px），已在 index.less 归一为 32px。
 * 3. Step2 的按钮指向 CJ 钱包（原型硬编码生产域名 https://cjdropshipping.com/mine/wallet），
 *    保持原值 —— 是否改成按环境取域名见执行计划 D5，未定前不擅自改跳转目标。
 */
import React from 'react';
import EmphasisText from './EmphasisText';
import { IconArrowBtn, IconArrowLong } from './Icons';

export default function Steps({ data }) {
  if (!data) return null;
  const cards = data.cards || [];

  return (
    <section className="wf-steps-section">
      <div className="wf-steps-container">
        {/* 强调词已内嵌在词条里（见 index.less 末尾「配色承接」段）；原
            <span class="wf-steps-heading-highlight"> 的渐变文字由 :extend 承接。 */}
        <h2 className="wf-steps-heading">
          <EmphasisText text={data.heading} />
        </h2>

        <div className="wf-steps-grid">
          {cards.map((c, i) => (
            <div className="wf-step-card" key={i}>
              <div className="wf-step-number">{c.num}</div>
              <h3 className="wf-step-title">{c.title}</h3>

              {c.text && <p className="wf-step-text">{c.text}</p>}

              {c.eitherText && (
                <p className="wf-step-either-text">
                  <EmphasisText text={c.eitherText} />
                </p>
              )}

              {c.options && (
                <div className="wf-step-options">
                  <div className="wf-step-option">
                    <span className="wf-step-option-check">✓</span>
                    <span className="wf-step-option-text">
                      <EmphasisText text={c.options[0].text} />
                    </span>
                  </div>
                  <div className="wf-step-or">
                    <span>{c.orText}</span>
                  </div>
                  <div className="wf-step-option">
                    <span className="wf-step-option-check">✓</span>
                    <span className="wf-step-option-text">
                      <EmphasisText text={c.options[1].text} />
                    </span>
                  </div>
                </div>
              )}

              <div className="wf-step-button-wrap">
                <a
                  className="wf-step-button"
                  href={c.btnUrl}
                  target={/^https?:/.test(c.btnUrl) ? '_blank' : undefined}
                  rel={/^https?:/.test(c.btnUrl) ? 'noopener noreferrer' : undefined}
                >
                  <span>{c.btnText}</span>
                  <IconArrowBtn />
                </a>
              </div>

              <div className="wf-step-image-wrap">
                <img className="wf-step-image" src={c.imageUrl} alt={c.imageAlt} loading="lazy" />
              </div>
            </div>
          ))}

          {/* 连接箭头：grid 的绝对定位子元素，压在卡片之间（不属于任何一张卡） */}
          <div className="wf-step-arrow wf-step-arrow--1">
            <IconArrowLong />
          </div>
          <div className="wf-step-arrow wf-step-arrow--2">
            <IconArrowLong />
          </div>
        </div>

        <div className="wf-steps-terms">
          {/* T&C 指向外部 PDF，新窗口打开（需求 260818 第 8 条） */}
          <a href={data.termsPdfUrl} target="_blank" rel="noopener noreferrer">
            {data.termsText}
          </a>
        </div>
      </div>
    </section>
  );
}
